import { SCREEN } from './Theme/screen';

/**
 * @summary Util to check if the device is mobile
 * @return {boolean} true / false
 */
const isMobile = () => SCREEN.width.medium700;
export { isMobile };
